<template>
  <VContent>
    <template slot="right">
      <span>طلبات منظومات الطاقة الشمسية</span>
    </template>
    <template slot="left">
      <b-button variant="success" class="mb-2" @click="exportToExcel">
        تصدير إلى Excel
      </b-button>
    </template>
    <template slot="content">
      <b-table
        :items="items"
        :fields="fields"
        :tbody-transition-props="transProps"
        tbody-tr-class="text-muted"
        responsive
        table-class="table-font h-100"
      >
        <template #cell(id)="data">
          {{ (page - 1) * 10 + data.index + 1 }}
        </template>
        <template v-slot:cell(username)="{ item }">
          {{ item.username }}
        </template>
        <template v-slot:cell(phone)="{ item }">
          {{ item.phone }}
        </template>
        <template v-slot:cell(province_id)="{ item }">
          {{ item.province_id }}
        </template>
        <template v-slot:cell(city_id)="{ item }">
          {{ item.city_id }}
        </template>
        <template v-slot:cell(number_of_amp)="{ item }">
          {{ item.number_of_amp }}
        </template>
        <template v-slot:cell(is_all_day)="{ item }">
          <span v-if="item.is_all_day" class="badge badge-success">نعم</span>
          <span v-else class="badge badge-danger">لا</span>
        </template>
        <template v-slot:cell(area_of_installation)="{ item }">
          {{ item.area_of_installation }}
        </template>
        <template v-slot:cell(created_at)="{ item }">
          {{ new Date(item.created_at).toISOString().slice(0, 10) }}
        </template>
        <template v-slot:cell(actions)="{ item }">
          <b-dropdown size="lg" variant="link" no-caret>
            <template #button-content>
              <b-icon icon="three-dots" animation="cylon"></b-icon>
            </template>
            <b-dropdown-item @click="remove(item.id)">
              <b-icon icon="archive" scale="0.5" class="ml-2"></b-icon>
              حذف
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </template>
    <template slot="bottom">
      <b-pagination
        v-model="page"
        :current-page="meta.current_page"
        :per-page="meta.per_page"
        :total-rows="meta.last_page * meta.per_page"
      ></b-pagination>
    </template>
  </VContent>
</template>

<script>
import {
  successAlert,
  errorAlert,
  showAlertWithConfirm,
  ImageURL,
} from "@/utils/helper";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      page: 1,
      readonly: false,
      transProps: {
        name: "flip-list",
      },
      fields: [
        { key: "id", label: "أ", sortable: true },
        { key: "username", label: "اسم المستخدم", sortable: true },
        { key: "phone", label: "رقم الهاتف", sortable: true },
        { key: "province_id", label: "المحافظة", sortable: true },
        { key: "city_id", label: "المدينة", sortable: true },
        { key: "number_of_amp", label: "عدد الأمبيرات", sortable: true },
        { key: "is_all_day", label: "طاقة على مدار اليوم", sortable: true },
        { key: "area_of_installation", label: "مساحة التركيب", sortable: true },
        { key: "created_at", label: "تاريخ الطلب", sortable: true },
        { key: "actions", label: "العمليات", sortable: false },
      ],
    };
  },
  computed: {
    items() {
      return this.$store.state.company.requests.list;
    },
    meta() {
      return this.$store.state.company.requests.meta;
    },
  },
  watch: {
    page() {
      this.getAll();
    },
  },
  mounted() {
    this.getAll();
  },
  methods: {
    getAll() {
      this.$store.dispatch("company/requests/get", this.page);
    },
    remove(id) {
      showAlertWithConfirm().then((response) => {
        if (response.isConfirmed) {
          this.$store
            .dispatch("company/requests/delete", id)
            .then(() => {
              successAlert();
              this.$store.commit("company/requests/DELETE_REQUEST", id);
            })
            .catch((error) =>
              errorAlert(
                error.response ? error.response.data.message : "فشل الحذف"
              )
            );
        }
      });
    },
    ImageURL(item) {
      return item.image ? item.image : ImageURL("user.jpg");
    },
    exportToExcel() {
      // Exclude id, bank, visitor fields
      const exportData = this.items.map(
        ({ id, bank, visitor, username, ...rest }) => rest
      );
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "طلبات منظومات الطاقة الشمسية");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "solar_system_requests.xlsx"
      );
    },
  },
};
</script>

<style lang="scss">
td[aria-colindex="2"] {
  text-align: right;
}
td[aria-colindex="3"] {
  direction: ltr;
}
</style>
